module.exports = __webpack_public_path__ + "img/home-53-hero_9x16_en_poster.6c1315f.jpg";